import { Fragment } from 'react';

import { IKnmPreview } from 'ApiPackage/SearchModule/interfaces/IKnmPreview';

import { KnmSubtitle } from './KnmSubtitle';
import styles from './styles.module.scss';

interface IKnmControlProps {
  passportData?: IKnmPreview;
}

export const KnmControl = ({ passportData }: IKnmControlProps) => (
  <div className={styles.ColumnContent}>
    <KnmSubtitle title="Орган прокуратуры">
      {passportData?.prosecName && (
        <div className={styles.Row}>
          <div className={styles.ColText}>Информация об органе контроля</div>
          <div className={styles.ColValue}>{passportData?.knoFullName}</div>
        </div>
      )}
    </KnmSubtitle>
    {passportData?.authorities && passportData?.authorities.length > 0 && (
      <>
        {passportData?.authorities.map((authority, authIndex) => (
          <Fragment key={authIndex}>
            <span className={styles.SectionTitle}>
              Орган контроля (надзора) из Федерального реестра государственных и муниципальных услуг (ФРГУ) проводящий
              КНМ
            </span>
            {authority.frguOrgId && (
              <div className={styles.Row}>
                <div className={styles.ColText}>
                  Идентификатор органа контроля (надзора) из Федерального реестра государственных и муниципальных услуг
                  (ФРГУ)
                </div>
                <div className={styles.ColValue}>{authority.frguOrgId}</div>
              </div>
            )}
            {authority.frguOrgName && (
              <div className={styles.Row}>
                <div className={styles.ColText}>
                  Наименование органа контроля (надзора) из Федерального реестра государственных и муниципальных услуг
                  (ФРГУ)
                </div>
                <div className={styles.ColValue}>{authority.frguOrgName}</div>
              </div>
            )}
            {authority.frguOrgOgrn && (
              <div className={styles.Row}>
                <div className={styles.ColText}>ОГРН органа государственного контроля (надзора)</div>
                <div className={styles.ColValue}>{authority.frguOrgOgrn}</div>
              </div>
            )}
            {authority.jointly && (
              <div className={styles.Row}>
                <div className={styles.ColText}>
                  Наименование органа контроля (надзора), совместно с которым проводится КНМ
                </div>
                <div className={styles.ColValue}>{authority.jointly}</div>
              </div>
            )}

            {authority.authorityServ && authority.authorityServ.length > 0 && (
              <>
                <span className={styles.SectionTitle}>Список Функции ФРГУ привязанных к проверке</span>
                {authority.authorityServ.map((serv, servIndex) => (
                  <Fragment key={servIndex}>
                    <span className={styles.SectionTitle}>
                      Контрольно-надзорная функция из Федерального реестра государственных и муниципальных услуг (ФРГУ),
                      привязанная к КНМ №1
                    </span>
                    {serv.frguServId && (
                      <div className={styles.Row}>
                        <div className={styles.ColText}>
                          Идентификатор контрольно-надзорной функции из Федерального реестра государственных и
                          муниципальных услуг (ФРГУ)
                        </div>
                        <div className={styles.ColValue}>{serv.frguServId}</div>
                      </div>
                    )}
                    {serv.frguServName && (
                      <div className={styles.Row}>
                        <div className={styles.ColText}>
                          Наименование контрольно-надзорной функции из Федерального реестра государственных и
                          муниципальных услуг (ФРГУ)
                        </div>
                        <div className={styles.ColValue}>{serv.frguServName}</div>
                      </div>
                    )}
                  </Fragment>
                ))}
              </>
            )}
          </Fragment>
        ))}
      </>
    )}
  </div>
);
